// https://www.w3.org/TR/wai-aria-practices-1.1/examples/combobox/aria1.1pattern/listbox-combo.html#ex2_label

import { BaseComponent } from "utils/base-component"
import { SearchResult, SearchSectionKind, SearchSection, SearchItem } from "./data"
import { Item } from "./item"
import css from "./style.module.scss"

let id = 0

type Config = {
  labelId?: string
  onChoose: (item: SearchItem) => void
}

const SECTION_TITLES: { [K in SearchSectionKind]: string | undefined } = {
  main: undefined,
  other: "Also found",
  nearby: "Our other forecasts near ",
}

export class List extends BaseComponent<Config> {
  static cssClass = css.list
  static tagName = "ul"
  private headers: HTMLElement[] = []
  private items: Item[] = []
  private selectedIndex: number = 0

  init() {
    this.root.id = `location-autocomplete-list-${id}`
    this.root.setAttribute("role", "listbox")
    if (this.config.labelId) this.root.setAttribute("aria-labelled-by", this.config.labelId)
    id += 1
  }

  async setState(query: string, result: SearchResult) {
    this.headers.forEach((header) => header.remove())
    this.headers = []
    this.items.forEach((item) => item.remove())
    this.items = []
    this.selectedIndex = 0

    if (result.length > 0) {
      result.forEach((section) => {
        this.addSection(query, section, SECTION_TITLES[section.kind])
      })
    }
  }

  selectedItem() {
    return this.items[this.selectedIndex].config.item
  }

  selectUp() {
    let index = this.selectedIndex - 1
    if (index < 0) index = this.items.length - 1
    this.select(index)
  }

  selectDown() {
    const index = (this.selectedIndex + 1) % this.items.length
    this.select(index)
  }

  private select(index: number) {
    this.items[this.selectedIndex].setSelected(false)
    this.items[index].setSelected(true)
    this.selectedIndex = index
  }

  private addSection(query: string, section: SearchSection, title?: string) {
    if (title) {
      const header = document.createElement("li")
      header.classList.add(css.section)
      header.appendChild(document.createTextNode(title))
      if (section.title) {
        const subtitle = document.createElement("span")
        subtitle.innerText = section.title
        subtitle.classList.add(css.sectionTitle)
        header.appendChild(subtitle)
      }
      header.appendChild(document.createTextNode(":"))
      this.root.appendChild(header)
      this.headers.push(header)
    }

    section.items.forEach((item) => {
      const row = new Item(null, { item, section, onChoose: this.config.onChoose })
      // row.setQuery(query)
      const index = this.items.length
      row.setSelected(index === this.selectedIndex)
      row.root.addEventListener("mouseover", () => {
        this.select(index)
      })
      this.appendChild(row)
      this.items.push(row)
    })
  }
}
